import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, formatError } from "../lib/api";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState(""); // honeypot
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", {
        email: email.trim().toLowerCase(),
        website,
      });
      setSent(true);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-xl px-6 py-16" data-testid="forgot-page">
      <h1 className="font-serif text-4xl font-semibold text-[#101A42] sm:text-5xl">
        {t("forgot_title")}
      </h1>
      <p className="mt-3 text-lg text-[#4A4A4A]">{t("forgot_intro")}</p>

      {sent ? (
        <div
          data-testid="forgot-sent-box"
          className="mt-8 rounded-2xl border-2 border-[#A762B1]/30 bg-[#A762B1]/10 p-6 text-lg text-[#101A42]"
        >
          {t("forgot_sent")}
          <div className="mt-4">
            <Link
              to="/login"
              className="font-semibold text-[#101A42] underline underline-offset-4"
              data-testid="back-to-login-link"
            >
              {t("login")}
            </Link>
          </div>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="mt-10 space-y-6">
          <div>
            <Label htmlFor="email" className="mb-2 block text-lg font-medium">
              {t("email")}
            </Label>
            <Input
              id="email"
              data-testid="forgot-email-input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-16 rounded-xl border-2 text-lg"
            />
          </div>

          {/* Honeypot: hidden field bots will fill, humans/screen readers won't */}
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              left: "-9999px",
              top: "-9999px",
              width: "1px",
              height: "1px",
              overflow: "hidden",
            }}
          >
            <label htmlFor="website">Website</label>
            <input
              id="website"
              type="text"
              name="website"
              tabIndex={-1}
              autoComplete="off"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>

          {error && (
            <div
              data-testid="forgot-error"
              className="rounded-xl border-2 border-[#A762B1]/30 bg-[#A762B1]/10 p-4 text-[#6E3978]"
            >
              {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={submitting}
            data-testid="forgot-submit-btn"
            className="min-h-[64px] w-full rounded-full bg-[#A762B1] text-xl font-semibold text-white hover:bg-[#B775C0]"
          >
            {submitting ? "..." : t("send_link")}
          </Button>
        </form>
      )}
    </div>
  );
}
